import {AdapterProps, FieldAdapter} from '../field-factory';
import {Slider as MantineSlider, SliderProps} from '@mantine/core';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $SliderAdapterProps = AdapterProps<SliderProps>;

export const $SliderAdapter: FC<FieldAdapter<$SliderAdapterProps>> = ({
  inputProps: {disabled, onChange, ...inputProps},
  control,
}) => {
  const {readOnly} = useContext(ReadOnlyContext);

  const {
    field: {onChange: fieldOnChange, ...fieldProps},
  } = control;

  const _onChange: SliderProps['onChange'] = (value) => {
    fieldOnChange(value);
    onChange?.(value);
  };

  return (
    <MantineSlider
      disabled={disabled || readOnly}
      onChange={_onChange}
      {...fieldProps}
      {...inputProps}
    />
  );
};